<template>
  <div class="swa-brand-banner-container">
    <UiBrandBanner
      v-element-visibility="[
        onBannerImpression,
        {
          threshold: 1,
          rootMargin: `${isMobile ? '-25%' : '-15%'} 0% 0%`,
        },
      ]"
      v-bind="props"
      @banner-clicked="onBannerClicked"
    />
  </div>
</template>

<script lang="ts" setup>
import { vElementVisibility } from '@vueuse/components'
import UiBrandBanner from '@sephora-asia/ui-brand-banner'
import type { BrandBannerContainerProps } from '~/types/components/contentful/components.types'

const { trackEvent } = useGtmTrack()
const { isMobile } = useDevice()

const props = defineProps<BrandBannerContainerProps>()

function onBannerImpression(isVisible: boolean) {
  if (isVisible) {
    trackEvent({
      event: 'cms_brand_banner_impression',
      params: {
        banner_name: props.internalName,
        content_banner_position: props.componentPosition,
        page_path: useRoute().path,
        segmented: props.isSegmented,
        segments: props.segments?.join(', '),
      },
    })
  }
}

function onBannerClicked(index: number) {
  trackEvent({
    event: 'cms_brand_banner_click',
    params: {
      banner_name: props.internalName,
      banner_position: index + 1,
      content_banner_position: props.componentPosition,
      page_path: useRoute().path,
      segmented: props.isSegmented,
      segments: props.segments?.join(', '),
    },
  })
}
</script>
<style lang="scss" scoped>
.swa-brand-banner-container {
  padding: 24px 16px;
  background-color: var(--color-base-grey-05);
}
</style>
